import React from "react";
import articleRequirements from "../../data/articleContent";
import arrowIcon from "../../assets/icons/arrow.png";
import { Link } from "react-router-dom";
import routes from "../../routes/routes";

// Fonction utilitaire pour transformer les emails en lien mailto et conserver les sauts de ligne
function linkifyEmail(text) {
    const emailRegex = /([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/g;
    const parts = text.split(emailRegex);

    return parts.map((part, i) => {
        if (emailRegex.test(part)) {
            return (
                <a
                    key={i}
                    href={`mailto:${part}`}
                    className="text-greenprimary underline break-all"
                >
                    {part}
                </a>
            );
        }
        // Gestion des sauts de ligne
        return part.split('\n').flatMap((line, j, arr) =>
            j < arr.length - 1
                ? [line, <br key={`${i}-${j}`} />]
                : [line]
        );
    });
}

const PublicationSection = () => {
    return (
        <div className="flex justify-center w-full">
            <div className="w-full max-w-7xl px-3 py-4 sm:px-6 sm:py-6">
                {articleRequirements.map((section, idx) => (
                    <div key={idx} className="mb-8">
                        <h2 className="text-greenlogo text-xl sm:text-2xl md:text-3xl font-semibold mb-2">
                            {section.title}
                        </h2>
                        <div className="whitespace-pre-line text-gray-800 text-justify">
                            {linkifyEmail(section.content)}
                        </div>
                    </div>
                ))}

                <div className="flex mt-10">
                    <Link
                        to={routes.propositionArticle}
                        className="bg-greenlogo text-white px-8 py-4 font-semibold flex items-center gap-3 transition-all hover:bg-greenlogo/90"
                    >
                        Publier dans Madatlas
                        <img src={arrowIcon} className="h-5 w-auto" alt="Voir plus" />
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default PublicationSection;